import React, { useEffect, useState } from "react";
import axios from "axios";

const TestConnection = () => {
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const testConnection = async () => {
      try {
        const apiUrl = process.env.REACT_APP_API_URL || 'http://127.0.0.1:5000';
        const testEndpoint = `${apiUrl}/api/test`;
        
        console.log("Testing connection to:", testEndpoint);
        
        const response = await axios.get(testEndpoint, {
          timeout: 5000,
          headers: {
            'Content-Type': 'application/json'
          },
          withCredentials: true // Include if you need to send cookies
        });
        
        console.log("Response:", response.data);
        setMessage(response.data.message);
        setError("");
      } catch (err) {
        console.error("Connection Failed:", err);
        
        let errorMessage = err.message;
        if (err.response) {
          // Server responded with a status code outside 2xx
          errorMessage = `Server error: ${err.response.status} - ${err.response.data?.message || 'No additional info'}`;
        } else if (err.request) {
          // Request was made but no response received
          errorMessage = "No response received from server";
        }
        
        setError(errorMessage);
        setMessage("");
      } finally {
        setIsLoading(false);
      }
    };
    
    testConnection();
  }, []);

  return (
    <div style={{ padding: '20px', maxWidth: '600px', margin: '0 auto' }}>
      <h1 style={{ color: '#2596be', textAlign: 'center' }}>API Connection Test</h1>
      
      {isLoading ? (
        <div style={{ textAlign: 'center', margin: '20px 0' }}>
          <p>Testing connection...</p>
          <div className="spinner"></div>
        </div>
      ) : (
        <>
          {message && (
            <div style={{
              padding: '15px',
              margin: '15px 0',
              backgroundColor: '#d4edda',
              color: '#155724',
              borderRadius: '4px',
              border: '1px solid #c3e6cb'
            }}>
              <strong>Success:</strong> {message}
            </div>
          )}
          
          {error && (
            <div style={{
              padding: '15px',
              margin: '15px 0',
              backgroundColor: '#f8d7da',
              color: '#721c24',
              borderRadius: '4px',
              border: '1px solid #f5c6cb'
            }}>
              <strong>Error:</strong> {error}
              <div style={{ marginTop: '10px', fontSize: '0.9em' }}>
                <p>Please check:</p>
                <ul>
                  <li>Backend server is running</li>
                  <li>CORS is properly configured</li>
                  <li>Network connectivity</li>
                </ul>
              </div>
            </div>
          )}
        </>
      )}
      
      <div style={{ marginTop: '20px', fontSize: '0.9em', color: '#666' }}>
        <p>Testing endpoint: <code>{process.env.REACT_APP_API_URL || 'http://127.0.0.1:5000'}/api/test</code></p>
      </div>
    </div>
  );
};

export default TestConnection;